import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPrompt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPrompt"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H7V6H4V9H2V4ZM17 4H22V9H20V6H17V4ZM7 9H17V11H7V9ZM7 13H15V15H7V13ZM4 15V18H7V20H2V15H4ZM22 15V20H17V18H20V15H22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPrompt;
